__turbopack_context__.v({
  "boldUnderline": "subtle-link-module-scss-module__A2FdOW__boldUnderline",
  "subtleLink": "subtle-link-module-scss-module__A2FdOW__subtleLink",
});
